import { SET_SKILL_GROUPS, SET_IS_LOADING } from '@/taskflex/skills/store/_types';

export default {
    [SET_SKILL_GROUPS](state, skillGroups) {
        state.skillGroups = skillGroups;
    },

    [SET_IS_LOADING](state, isLoading) {
        state.isLoading = isLoading;
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/skills/store/_mutators.js